import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Retentions from "@/pages/Retentions";
import Upload from "@/pages/Upload";
import BulkPayment from "@/pages/BulkPayment";
import Vouchers from "@/pages/Vouchers";
import Users from "@/pages/Users";
import Roles from "@/pages/Roles";
import StatusOptions from "@/pages/StatusOptions";
import Reports from "@/pages/Reports";
import Projects from "@/pages/Projects";
import Parties from "@/pages/Parties";
import AuditLog from "@/pages/AuditLog";
import HRCompliance from "@/pages/HRCompliance";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<ProtectedRoute module="dashboard"><Dashboard /></ProtectedRoute>} />
              <Route path="/invoices" element={<ProtectedRoute module="invoices"><Invoices /></ProtectedRoute>} />
              <Route path="/invoices/:id" element={<ProtectedRoute module="invoices"><InvoiceDetail /></ProtectedRoute>} />
              <Route path="/bulk-payment" element={<ProtectedRoute module="payments"><BulkPayment /></ProtectedRoute>} />
              <Route path="/bulk-payment/:voucherNo" element={<ProtectedRoute module="payments"><BulkPayment /></ProtectedRoute>} />
              <Route path="/vouchers" element={<ProtectedRoute module="payments"><Vouchers /></ProtectedRoute>} />
              <Route path="/retentions" element={<ProtectedRoute module="retentions"><Retentions /></ProtectedRoute>} />
              <Route path="/upload" element={<ProtectedRoute module="excel_upload"><Upload /></ProtectedRoute>} />
              <Route path="/reports" element={<ProtectedRoute module="reports"><Reports /></ProtectedRoute>} />
              <Route path="/hr-compliance" element={<ProtectedRoute module="hr_compliance"><HRCompliance /></ProtectedRoute>} />
              <Route path="/projects" element={<ProtectedRoute module="projects"><Projects /></ProtectedRoute>} />
              <Route path="/parties" element={<ProtectedRoute module="parties"><Parties /></ProtectedRoute>} />
              <Route path="/audit-log" element={<ProtectedRoute module="audit_log"><AuditLog /></ProtectedRoute>} />
              <Route path="/users" element={<ProtectedRoute module="users"><Users /></ProtectedRoute>} />
              <Route path="/roles" element={<ProtectedRoute module="roles"><Roles /></ProtectedRoute>} />
              <Route path="/status-options" element={<ProtectedRoute module="status_options"><StatusOptions /></ProtectedRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
